import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs';

export const JwtInterceptor: HttpInterceptorFn = (request, next) => { 

  if(request.url.indexOf('/applog/') > -1) {
    // pass applog url through without token
    return next(request);
  }

  // Allow login endpoints without token
  if(request.url.indexOf('/user/login') > -1 || request.url.indexOf('/user/buildinfo') > -1) {
    return next(request);
  }

  let token = localStorage.getItem('id_token');

  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
  return next(request).pipe(

    // log all errors
    catchError((err: any) => { 
      // not necessary...
      throw err;
    }), 

    // check for response header
    map(event => {
      if (event instanceof HttpResponse) {
        var token:string = event.headers.get('Set-Authorization') || '';
        if(token) {
          localStorage.setItem('id_token', token);
        }
      }
      return event;
    })
  );

}
